import axiosInstance from './axiosInstance';

const fetchLeaderboard = () => {
    return axiosInstance.get('/leaderboard');
};

export const leaderboardService = {
    fetchLeaderboard,
};
